import axiosInstance from "../instance/AxiosInstance";

export const staffViewEffect = (id) => {
  return axiosInstance
    .get(`/staffs/getstaff?staff_id=${id}`)
    .then((response) => {
      return response;
    })
    .catch((error) => {
      throw error;
    });
};

export const staffAddEffect = async (payload) => {
  try {
    const response = await axiosInstance.post("/staffs/insert", payload);

    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to Add Staff";
  }
};
export const staffUpdateEffect = async (payload) => {
  try {
    const response = await axiosInstance.put(
      `/staffs/updatestaff/${payload.id}`,
      payload
    );

    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to Update Staff";
  }
};

export const staffViewAllEffect = async (payload) => {
  const params = {};

  if (payload.search) {
    params.pagination_required = true;
    params.pagesize = payload.pagesize;
    params.pageNo = payload.pageNo;
    params.search = payload.search;

    if (payload.search_by && payload.search_by.trim() !== "") {
      params.search_by = payload.search_by;
    }
  } else {
    params.pagination_required = true;
    params.pagesize = payload.pagesize;
    params.pageNo = payload.pageNo;
  }
  try {
    const response = await axiosInstance.get(`/staffs/list`, { params });

    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to Update Staff";
  }
};
export const staffFetchAllEffect = async () => {
  try {
    const response = await axiosInstance.get(`/staffs/list`);

    return response.data;
  } catch (error) {
    throw error.response?.data?.message || "Failed to Update Staff";
  }
};

export const staffDeleteEffect = async (payload) => {
  try {
    const response = await axiosInstance.delete(
      `/staffs/deletestaff/${payload}`
    );

    return response;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to Delete Staff");
  }
};
export const handleApiError = (error) => {
  if (error.response) {
    const errorData = error.response.data || {};
    const errorFields = errorData.errorFields || {};
    return {
      statusCode: error.response.status,
      email: errorFields.email || null,
      phone: errorFields.phone || null,
      contact: errorFields.contact || null,
      additionalErrors: errorFields,
      message: errorData.message || "Unknown error occurred.",
    };
  } else if (error.request) {
    return {
      statusCode: null,
      message: "No response received from the server. Please try again later.",
    };
  } else {
    return {
      statusCode: null,
      message: error.message || "An unexpected error occurred.",
    };
  }
};
